export default __webpack_public_path__ + "static/media/check.505eefa9.svg";